import { api } from '../../lib/api';

export type ImportGroupDecision = {
  canonicalKey: string;
  name: string;
  existingAccountId?: string | null;
};

export type ImportRow = {
  groupCanonicalKey: string;
  franchiseSuburb: string;
  franchiseSuburbShort: string | null;
  franchiseSuburbSlug: string | null;
  state: string;
  metaMasterMonthlyBudget: number | null;
  googleMasterMonthlyBudget: number | null;
  // Round-5 (null=inherit): all three nullable. null means
  // "inherit from brand landingPageTemplate" at render time.
  offerLandingPage: string | null;
  saleLandingPage: string | null;
  locationLandingPage: string | null;
  defaultFormType: 'Generic' | 'Qualifying Question';
  // Round 6 (Map columns + set defaults): bulk-set value picked
  // in Table 2 of the mapping step. Null === "no default" (the
  // legacy import behaviour); 'traffic' / 'lead_gen' === bulk-
  // set value lands on every imported location profile.
  defaultMetaAdType: 'traffic' | 'lead_gen' | null;
  gymInfo: string | null;
  package: string | null;
  clubOpenedAt: string | null;
  // These flow through to the location Account (not the location profile)
  // because they're per-location ad-account identifiers, not franchise template
  // data. Set to null for rows where the sheet's cell is empty or a placeholder.
  fbAdAccountId: string | null;
  fbAdAccountUrl: string | null;
  googleAdsCustomerId: string | null;
  crmId: string | null;
  googleAdsUrl: string | null;
  clientDriveUrl: string | null;
  reportUrl: string | null;
};

export type ImportPayload = {
  groups: ImportGroupDecision[];
  rows: ImportRow[];
};

export type ImportResult = {
  brandId: string;
  groupsCreated: Array<{ accountId: string; name: string; canonicalKey: string }>;
  groupsReused: Array<{ accountId: string; name: string; canonicalKey: string }>;
  locationsCreated: Array<{ accountId: string; franchiseSuburb: string; parentAccountId: string }>;
  locationsSkipped: Array<{ franchiseSuburb: string; reason: string }>;
  errors: Array<{ franchiseSuburb: string; error: string }>;
};

export async function importLocations(
  brandAccountId: string,
  payload: ImportPayload,
): Promise<ImportResult> {
  const res = await api<{ result: ImportResult }>(
    `/api/accounts/${brandAccountId}/import-locations`,
    { method: 'POST', body: JSON.stringify(payload) },
  );
  return res.result;
}
